import React from 'react'
import { navigate } from 'gatsby'

import img_title_premios from '../../../assets/images/title_premios.png'

import useMediaQuery from '../../../utils/useMediaQuery'
import Button from '../../atoms/button/button'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './content-awards.scss'
import { datesFaseActivities } from '../../../constants/activity-constants'
import formatDateStr from '../../../utils/formatDateStr'
import { 
  ImageByCountry1,
  text_replica_content_awards1, 
  text_replica_content_awards2,
  text_replica_content_awards3,
  text_replica_content_awards6,
  text_replica_content_description_awards
} from './replica-content-awards'

const ContainerInfo = ({ fase2 }) => {
  return (
    <div className="f-content-awards-right__wrapper-info__container">
      <span
        className={`f-content-awards-right__wrapper-info__container__title ${
          fase2 && 'blue'
        }`}
      >
        <h2>Fase {fase2 ? '2' : '1'}</h2>
        <p className='f-content-awards-right__wrapper-info__container__time-event'>
          {fase2
            ? formatDateStr(datesFaseActivities.datesTopFase2Front)
            : formatDateStr(datesFaseActivities.datesTopFase1)}
        </p>
      </span>
      <div className="f-content-awards-right__wrapper-info__container__content">
        <p>
            {text_replica_content_awards3}
        </p>
        <ul>
          {text_replica_content_description_awards}
        </ul>
      </div>
    </div>
  )
}

const ContentAwards = () => {
  const isMobile = useMediaQuery()
  const userInfo = getUserInfo()

  return (
    <div className="f-content-awards-container">
      <section className="f-content-awards-left">
        <div className="f-content-awards-left__info-box">
          <img src={img_title_premios} alt="titulo premios" />
          <h2>
            {text_replica_content_awards6}
          </h2>
          {text_replica_content_awards1}
          <p>
            {text_replica_content_awards2}
          </p>
        </div>
      </section>
      <section className="f-content-awards-right">
        <ImageByCountry1 isMobile = {isMobile} classname={'f-content-awards-right__img-premios'}/>
        <div className="f-content-awards-right__wrapper-info">
          <ContainerInfo />
          <ContainerInfo fase2 />
        </div>
        <Button
          onClick={async () => {
            pushEventData({
              event: 'Interacciones_Premios_UCole',
              label: '¡Quiero jugar ya!',
              action: 'click',
              user_data: userInfo && [
                await jsonToHash({
                  nombre: userInfo.name,
                  apellido: userInfo.lastName,
                  celular: userInfo.cellPhone,
                  correo: userInfo.email,
                  ciudad: userInfo.location.cityName,
                  departamento: userInfo.location.countryStateName,
                  pais: userInfo.countryName,
                }),
              ],
              log_status: userInfo ? 'Yes' : 'Not',
            })
            navigate('/jugar')
          }}
        >
          ¡Quiero jugar ya!
        </Button>
      </section>
    </div>
  )
}

export default ContentAwards
